import { createContext } from "react";

// Create the context to share data between components
const userContext = createContext(null);

export default userContext;